var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dateRow text-center"},[_c('div',{staticClass:"dateRow__dataBox badge-pill d-inline-block"},[_c('small',[_vm._v(_vm._s(_vm.filterWeek(this.timeData)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }